import { saveUserImage } from '@utils/api';
import { isErrorMessage } from '@utils/error';
import { PictureFormat } from '@utils/image';
import { useState, useCallback } from 'react';

export function useSaveUserImage(options: { imageUrl?: string | null }) {
  const { imageUrl } = options;
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState<string | undefined>(imageUrl || undefined);

  const uploadImage = useCallback(async (options?: { format: PictureFormat; value?: string }) => {
    const format = options?.format || 'image';
    setLoading(true);
    const saveImageResponse = await saveUserImage({
      format,
      value: options?.value,
    });
    if (!isErrorMessage(saveImageResponse))
      setUrl(saveImageResponse.imageUrl + (format === 'image' ? `?${Date.now()}` : ''));
    setLoading(false);
  }, []);

  return {
    uploadImage,
    url: url || imageUrl,
    loading,
  } as const;
}
